import React, { useContext, useState, useEffect, useRef } from 'react';
import { store } from 'components/Store';
import StakeHolderNoMogulUsers from 'components/Dashboard/StakeHolders/StakeHolderNoMogulUsers';
import { useAuth0 } from '@auth0/auth0-react';
import SkeletonKeyUpdates from './SkeletonKeyUpdates';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';

const NoAllowedReference = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan } = state;
  const { enableReferenceSection } = activePlan;
  const [isLoading, setIsLoading] = useState(true);
  const { isAuthenticated } = useAuth0();
  const { addMetaTags } = useAddMetaTags();

  const initialCall = useRef(null);
  initialCall.current = () => {
    let activePlanItems = Object.keys(activePlan);
    if (activePlanItems.length > 0 || !isAuthenticated) {
      setIsLoading(false);
      if (!enableReferenceSection) {
        setPageTitle();
      }
    }
  };

  useEffect(() => {
    initialCall.current();
  }, []);

  const setPageTitle = () => {
    let title = `Reference - PolicyMogul`;
    let hash = '';
    addMetaTags({ title, hash });
  };

  return (
    <>
      {isLoading && <SkeletonKeyUpdates />}
      {!isLoading && (
        <>
          <StakeHolderNoMogulUsers
            title={'Search the political landscape'}
            subtext={
              'Search current and historic political updates from hundreds of official and unofficial sources across the UK'
            }
            image={'/images/20220210-reference-screenshot.png'}
          />
        </>
      )}
    </>
  );
};

export default NoAllowedReference;
